import {Component, ViewChild} from "@angular/core";
import {NavigationService} from "../../orchestration/navigation.service";
import {Page} from "../../orchestration/page";
import {MessageDetails, MessageLevel} from "../../notification/message/message";
import {NotificationService} from "../../notification/notification.service";
import {IdentityModel} from "../identity.model";
import {FormComponent} from "../../inputs/form/form.component";
import {IdentityChangePasswordService} from "../identity-change-password.service";

@Component({
    selector: "woa-change-password-page",
    templateUrl: "change-password-page.component.html",
    providers: [
        IdentityChangePasswordService,
        {provide: Page, useExisting: ChangePasswordPageComponent}
    ]
})
export class ChangePasswordPageComponent extends Page {
    @ViewChild(FormComponent) public form: FormComponent;

    oldPassword: string;
    newPassword: string;

    constructor(private notificationService: NotificationService,
                private navigationService: NavigationService,
                private identityChangePasswordService: IdentityChangePasswordService,
                public identityModel: IdentityModel) {
        super();
    }

    async changePassword(): Promise<void> {
        if (!this.form.valid) {
            return;
        }

        try {
            await this.identityChangePasswordService.performAction({
                oldPassword: this.oldPassword,
                newPassword: this.newPassword
            });
            // noinspection ES6MissingAwait
            this.navigationService.dismissPage(this);
        } catch (error) {
            if (error.displayable) {
                this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, error.data.messageKey, error.data.messageParams));
            } else {
                this.notificationService.displayFooterMessage(new MessageDetails(MessageLevel.ERROR, "woa.notification.passwordChangeFailed"));
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/identity/change-password-page/change-password-page.component.ts